import { useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import Breadcrumbs from '@components/Breadcrumbs'
import { Button } from '@components/ui/button'
import Card from '@components/Card'
import { useTheme } from '@components/ThemeProvider'

const NotFound = ({
  title = 'Page not found',
  message = "Sorry, we couldn't find what you're looking for. It might have been moved or deleted.",
  breadcrumbs = null,
  backTo = null,
  backLabel = 'Go back',
  className = ''
}) => {
  const navigate = useNavigate()
  const { resolvedTheme } = useTheme()

  const handleGoBack = () => {
    if (backTo) {
      navigate(backTo)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={`h-screen w-full flex flex-col ${className}`}>
      <If condition={breadcrumbs}>
        <div className="w-full bg-white flex flex-col justify-between">
          <Breadcrumbs>
            {breadcrumbs}
          </Breadcrumbs>
        </div>
      </If>

      <div className='w-auto flex flex-col items-center justify-center p-10 m-5'>
        <Choose>
          <When condition={resolvedTheme === 'dark'}>
            <img src='/searching-dark.svg' alt='Student reading' className='w-[120px] self-center mb-5' />
          </When>
          <Otherwise>
            <img src='/searching.svg' alt='Student reading' className='w-[120px] self-center mb-5' />
          </Otherwise>
        </Choose>
        <h4 className='text-2xl font-semibold mb-2'>{title}</h4>
        <p className='text-center text-gray-600 mb-4 max-w-lg'>
          {message}
        </p>
        <If condition={backTo || backTo !== false}>
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center gap-2"
          >
            <ChevronLeft size={16} />
            {backLabel}
          </Button>
        </If>
      </div>
    </div>
  )
}

export default NotFound 
